import { required, minLength, url } from 'vuelidate/lib/validators'

const isAtLeastFrom =
  (to, vm) => {
    let from = vm.veranstaltungStart
    if (to && from) {
      return from <= to
    } else {
      return true
    }
  }

export default {
  organisationseinheit: {
    name: { required, minLength: minLength(1) }
  },
  name: { required, minLength: minLength(1) },
  veranstaltungsTyp: { required, minLength: minLength(1) },
  veranstaltungStart: { required },
  veranstaltungEnde: { required, isAtLeastFrom },
  externeWebsite: { url }
}



// WEBPACK FOOTER //
// ./src/validation/Veranstaltung.js